// composables/usePageStayTime.js
import { ref, onMounted, onUnmounted } from 'vue'

export function usePageStayTime() {
  const stayTime = ref(0)
  let startTime = 0
  let timer = null
  let isPageHidden = false

  // 发送数据到服务器（使用sendBeacon确保关闭时也能发送）
  const sendStayTimeToServer = (seconds) => {
    const data = {
      type: "1",
      url: window.location.href,
      second: seconds,
      timestamp: new Date().toISOString()
    }

    // 使用sendBeacon在页面卸载时可靠发送
    const blob = new Blob([JSON.stringify(data)], { type: 'application/json' })
    navigator.sendBeacon('/api/ckbop/front/account/Log', blob)

    console.log(`上报停留时间: ${seconds}秒`, data)
  }

  // 处理页面可见性变化
  const handleVisibilityChange = () => {
    if (document.hidden) {
      // 页面隐藏
      isPageHidden = true
      const hiddenTime = Math.floor((Date.now() - startTime) / 1000)
      sendStayTimeToServer(hiddenTime)
    } else {
      // 页面重新显示
      isPageHidden = false
      startTime = Date.now() // 重置开始时间
    }
  }

  // 处理页面卸载
  const handleBeforeUnload = () => {
    const totalTime = Math.floor((Date.now() - startTime) / 1000)
    // sendStayTimeToServer(totalTime)
  }

  onMounted(() => {
    startTime = Date.now()

    // 定时更新停留时间
    timer = setInterval(() => {
      if (!isPageHidden) {
        stayTime.value = Math.floor((Date.now() - startTime) / 1000)
      }
    }, 1000)

    // 添加事件监听
    // document.addEventListener('visibilitychange', handleVisibilityChange)
    // window.addEventListener('beforeunload', handleBeforeUnload)
  })

  onUnmounted(() => {
    // 清除定时器和事件监听
    clearInterval(timer)
    // document.removeEventListener('visibilitychange', handleVisibilityChange)
    // window.removeEventListener('beforeunload', handleBeforeUnload)

    // 组件卸载时也上报数据
    if (!isPageHidden) {
      const totalTime = Math.floor((Date.now() - startTime) / 1000)
      // sendStayTimeToServer(totalTime)
    }
  })

  return { stayTime }
}